import React from 'react';
import { Button, Flex, theme, Typography } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import useTrackSetupChecklistEvent from './useTrackChecklistEvent';

type TitleProps = {
  title: string;
  subtitle: React.ReactNode;
  isCompleted: boolean;
};
export function Title({ title, subtitle, isCompleted }: TitleProps) {
  const { token } = theme.useToken();

  const iconSize = 24;

  return (
    <Flex gap="small" align="center">
      {isCompleted && <CheckCircleFilled style={{ color: token.colorPrimary, fontSize: iconSize }} />}
      <div>
        <Typography.Text strong style={{ color: isCompleted ? token.colorTextQuaternary : undefined }}>
          {title}
        </Typography.Text>
        <br />
        {subtitle}
      </div>
    </Flex>
  );
}

type SubtitleProps = {
  isCompleted: boolean;
  reviewLink: string;
  reviewText: string;
  description: string;
  itemKey: string;
};
export function Subtitle({ isCompleted, reviewLink, reviewText, description, itemKey }: SubtitleProps) {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const trackSetupChecklistEvent = useTrackSetupChecklistEvent();
  
  const handleReviewClick = () => {
    trackSetupChecklistEvent('ItemClicked', { item_name: itemKey, is_completed: isCompleted });
    navigate(reviewLink);
  };

  if (isCompleted) {
    return (
      <Typography.Text style={{ color: token.colorTextQuaternary }}>
        Completed ·{' '}
        <Button type='link' onClick={handleReviewClick} size='small' style={{ padding: 0 }}>
          {reviewText} →
        </Button>
      </Typography.Text>
    );
  }

  return <Typography.Text type="secondary">{description}</Typography.Text>;
}
